import View from "../account/views/auth/login";
import components from "./components.js";
components.define("js-login-toggle", View);